import { render, staticRenderFns } from "./GlBaseModal.vue?vue&type=template&id=824416aa&scoped=true"
import script from "./GlBaseModal.vue?vue&type=script&lang=js"
export * from "./GlBaseModal.vue?vue&type=script&lang=js"
import style0 from "./GlBaseModal.vue?vue&type=style&index=0&id=824416aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824416aa",
  null
  
)

export default component.exports